import * as React from "react";
import { messageListingReducer } from "./messageListingReducer";
import {
    initialMessageListingState,
    MessageListingState,
} from "./messageListingState";
import {
    useMessageSearchActions,
    MessageSearchActions,
} from "./messageListingActions";
import { useMessageListingHandlers } from "./messageListingHandlers";

type MessageSearchContextType = {
    state: MessageListingState;
    actions: MessageSearchActions;
};
export const MessageListingContext = React.createContext<MessageSearchContextType>(
    undefined
);

export const MessageListingProvider = (props: any) => {
    const [state, dispatch] = React.useReducer(
        messageListingReducer,
        initialMessageListingState
    );

    const actions = useMessageSearchActions(state, dispatch);
    useMessageListingHandlers(state, actions);
    const value = React.useMemo(() => ({ state, actions }), [
        state,
        actions,
    ]) as MessageSearchContextType;

    return <MessageListingContext.Provider value={value} {...props} />;
};

export const useMessageSearch = () => {
    const ctx = React.useContext(MessageListingContext);

    if (!ctx) {
        throw new Error(
            "Cannot call useMessageSearch outside of a MessageListingProvider"
        );
    }

    return ctx;
};
